<template>
  <v-dialog :value="value" width="1000px" persistent @input.self="$emit('input', $event)">
    <import-dynamic-csv-card v-bind="$attrs" :isModalOpen="value" @close-dialog="closeDialog" />
  </v-dialog>
</template>

<script>
// import CSV from 'csv-string'
export default {
  name: 'ImportDynamicCsv',
  components: {
    ImportDynamicCsvCard: () => import('./ImportDynamicCsvCard.vue'),
  },
  props: {
    value: Boolean,
  },
  methods: {
    closeDialog(inputCondition) {
      this.$emit('input', inputCondition)
    },
  },
}
</script>

<style lang="scss">
.import-clients {
  .import-col {
    cursor: pointer;
    user-select: none;
  }
  .hidden-input {
    display: none;
  }
  .text {
    opacity: 0.87;
    max-width: 300px;
    &.import {
      color: $marca-0-l40;
    }
    &.import-hint {
      font-size: 12px;
      opacity: 0.54;
    }
  }
  .category-box {
    .select-label {
      opacity: 0.87;
    }
    .disabled-opacity {
      opacity: 0.54;
    }
  }
  .preview-col {
    background-color: $cinza-l90;
    border-radius: 4px;
    border: 1px solid $cinza-l30;
    padding: 2px;
  }

  .preview-row {
    overflow-x: auto;
    max-width: 600px;
  }

  table.preview-table {
    background-color: $cinza-l90;
    max-width: 580px;
    min-width: 200px;
    text-align: left;
    border-collapse: collapse;
    border: 1px solid $cinza-l30;
  }
  table.preview-table td,
  table.preview-table th {
    border: 1px solid $cinza-l30;
    padding: 10px 10px;
  }
  table.preview-table thead {
    background: $cinza-l90;
    border-bottom: 3px solid $cinza-l30;
  }
  table.preview-table thead th {
    text-align: left;
  }
}
</style>
